import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
/** Represents a components that encapsulates the children in a shadow root. */
export const ShadowDom = ({ mode = 'closed', resetStyles = true, delegatesFocus = false, stylesheets, children, }) => {
    const [shadowRoot, setShadowRoot] = useState();
    const handleShadowHostRef = useCallback((shadowHost) => {
        if (shadowHost && !shadowRoot) {
            const shadowRoot = shadowHost.attachShadow({
                delegatesFocus,
                mode,
            });
            if (resetStyles) {
                const style = document.createElement('style');
                style.textContent = ':host { all: initial; }';
                shadowRoot.appendChild(style);
            }
            if (stylesheets) {
                stylesheets.forEach((stylesheet) => {
                    const style = document.createElement('style');
                    style.textContent = stylesheet;
                    shadowRoot.appendChild(style);
                });
            }
            setShadowRoot(shadowRoot);
        }
    }, [delegatesFocus, mode, shadowRoot, stylesheets]);
    return (_jsx("div", Object.assign({ ref: handleShadowHostRef }, { children: shadowRoot
            ? createPortal(children, shadowRoot)
            : children })));
};
